export default __webpack_public_path__ + "static/media/slider.f46116fb.png";